<template lang="pug">
.wrap
  .main
    .new-question
      .panel-header
        | {{ isNewQuestion ? 'Add new question' : 'Edit question' }}
        el-button(type='primary' size='small' v-if='!isNewQuestion' @click='resetNewQuestion' :style='{ float: "right" }') Add new

      el-form(ref="questionForm" :rules='questionRules' :model="question")
        el-form-item(label='Multiple Choice Question' prop='question')
          el-input(type='textarea' :autosize="{ minRows: 4, maxRows: 10}" v-model='question.question')

        .answers
          transition-group(name='el-fade-in')
            el-form-item(v-for='(answer, answerIndex) in question.answers' :key='answerIndex + 0')
              .answer-item
                .answer-item-input
                  el-input(v-model='answer.answer' :placeholder='`Enter ${answer.isCorrect ? "correct" : "wrong"} answer`')

                .answer-item-actions
                  .answer-item-action(v-if='answer.isCorrect')
                    icon(name="check" color='#7fc4be')

                  .answer-item-action.remove(v-else @click='removeAnswer(answerIndex)')
                    icon(name="times" color='#999')

          el-button(@click='addWrongAnswer') + Add another incorrect answer

        .new-question-actions
          el-button(v-if='isNewQuestion' type='primary' @click='submitQuestionForm') Save question

  .side
    .questions(v-loading="loading")
      .questions-empty(v-if='!questions.length') No questions yet.

      transition-group(name='el-fade-in')
        .question-entry(v-for='(question, questionIndex) in questions' :key='questionIndex + 0' @click='setEditingQuestion(question)')
          .question-content {{ question.question }}
          .question-answer-count {{ question.answers.length }} answers:

          .question-answer-options
            .question-answer-option(v-for='(answer, answerIndex) in question.answers' :key='answerIndex')
              | {{ answer.answer }}
              icon.question-answer-option-correct(name="check" color='#7fc4be' v-if='answer.isCorrect' :scale='0.8')

          .question-actions(@click.stop='')
            el-popover(placement='bottom' width='200px')
              .question-action(slot='reference')
                icon(name="ellipsis-v" color='#999')
              .question-action-menu
                .question-action-menu-item(@click='deleteQuestion(questionIndex)') Delete...

</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";

const NEW_QUESTION_DATA = {
  question: "",
  new: true,
  answers: [{ answer: "", isCorrect: true }, { answer: "", isCorrect: false }]
};

export default {
  model: {
    prop: "questions",
    event: "change"
  },
  props: {
    questions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      question: _.cloneDeep(NEW_QUESTION_DATA),
      questionRules: {
        question: [
          { required: true, message: "This field is required", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    isNewQuestion() {
      return this.question.new;
    }
  },
  methods: {
    ...mapActions({
      addQuestion: "briefs/addQuestion",
      fetchQuestions: "briefs/fetchQuestions",
      deleteQuestion: "briefs/deleteQuestion",
      updateQuestion: "briefs/updateQuestion"
    }),
    submitQuestionForm() {
      const form = this.$refs.questionForm;
      form.validate(valid => {
        if (!valid) {
          return;
        }

        this.questions.push({ ...this.question, new: false });
        this.resetNewQuestion();
      });
    },
    addWrongAnswer() {
      this.question.answers.push({ answer: "", isCorrect: false });
    },
    removeAnswer(index) {
      this.question.answers.splice(index, 1);
    },
    setEditingQuestion(question) {
      this.question = question;
    },
    deleteQuestion(index) {
      this.questions.splice(index, 1);
      this.resetNewQuestion();
    },
    resetNewQuestion() {
      this.question = _.cloneDeep(NEW_QUESTION_DATA);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/scss/mixins.scss";
.wrap {
  display: flex;
  background: white;
  padding: 0;
  @include MQ(M) {
    // flex-basis: auto;
    min-height: 100%;
    flex-direction: column;
  }
}

.main {
  flex-basis: 50%;
  padding-right: 20px;
  border-right: 1px solid #ddd;
  @include MQ(M) {
    padding: 0;
    border: none;
    flex-basis: auto;
  }
}

.side {
  flex-basis: 50%;
  @include MQ(M) {
    flex-basis: auto;
  }
}

.panel-header {
  font-size: 24px;
  font-family: "gilroylight";
  margin-bottom: 20px;
}

.questions {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.question-entry {
  margin-bottom: 10px;
  border: 1px solid #ccc;
  background: #eff0f2;
  padding: 10px;
  font-size: 13px;
  cursor: pointer;
  position: relative;
  border-radius: 2px;
}

.question-content {
  flex: 1;
  font-size: 15px;
  margin-bottom: 5px;
}

.question-answer-count {
  font-size: 12px;
  font-weight: 600;
  margin-top: 5px;
}

.question-actions {
  position: absolute;
  top: 5px;
  right: 5px;
}

.question-action {
  padding: 4px;
  cursor: pointer;

  &:hover {
    background: #fff;
  }
}

.question-action-menu {
  font-size: 14px;
  margin: -10px;
}

.question-action-menu-item {
  cursor: pointer;
  border-bottom: 1px solid #eee;
  padding: 8px 10px;

  &:last-child {
    border-bottom: 0;
  }
}

.questions-empty {
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.answer-item {
  display: flex;
  align-items: center;
}

.answer-item-input {
  flex: 1;
}

.answer-item-actions {
  flex: 0 0 6%;
  display: flex;
  align-items: center;
}

.answer-item-action {
  margin-left: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.new-question-actions {
  border-top: 1px solid #ddd;
  padding-top: 20px;
  margin-top: 20px;
}

.question-answer-options {
  background: white;
  border-radius: 2px;
  margin-top: 10px;
}

.question-answer-option {
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  position: relative;

  &:last-child {
    border-bottom: 0;
  }
}

.question-answer-option-correct {
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
